import React, { useState } from 'react';
import { WorkflowInputLayout } from './WorkflowInputLayout';
import InfrastructureTab from '../../../components/utility_planning/scenarioInputs/InfrastructureTab';

const defaultInfrastructure = {
  capacityMapSource: 'default',
  chargingInfraSource: 'default',
  poisSource: 'default',
  uploads: {},
};

export default function ChargingInfraInputPage() {
  const [data, setData] = useState(defaultInfrastructure);
  const updateData = (next) => setData((prev) => ({ ...prev, ...next }));

  return (
    <WorkflowInputLayout title="Charging infra">
      <div className="space-y-3">
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 font-ui">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-medium">Station map overlays</span>
            <span className="inline-flex items-center rounded-full border border-amber-300 bg-white px-2 py-0.5 text-[11px] font-medium text-amber-700">
              in development
            </span>
          </div>
          Public charger and upcoming-station map workflows for MDHD planning are being added.
        </div>
        <div className="bg-white rounded-xl shadow-lg font-ui">
        <InfrastructureTab data={data} updateData={updateData} region="CA" />
        </div>
      </div>
    </WorkflowInputLayout>
  );
}
